import type { CSSProperties, ReactElement, ReactNode } from "react";
import styled from "styled-components";
import { InputBlock } from "src/components/SearchInput/SearchInput";
import { twJoin } from "tailwind-merge";

type Props = {
  icon?: ReactElement;
  inputText?: string;
  label: string | ReactNode;
  ariaLabel: string;
  ariaExpanded: boolean;
  handleInputClick: () => void;
  placeholder?: string;
  id: string;
  onClickCta?: () => void;
  focusRef?: React.RefObject<HTMLButtonElement>;
  isChildExpanded?: boolean;
  pillBorderColor?: CSSProperties["color"];
  disabled?: boolean;
  handleClear?: () => void;
};

export function HotelInputPicker(props: Props) {
  const {
    icon,
    handleInputClick,
    label,
    ariaLabel,
    ariaExpanded,
    focusRef,
    inputText,
    id,
    isChildExpanded,
    disabled,
    ...delegated
  } = props;

  return (
    <StyledInputBlock
      onClick={handleInputClick}
      as="button"
      role="combobox"
      id={id}
      aria-label={ariaLabel}
      aria-expanded={ariaExpanded}
      ref={focusRef}
      disabled={disabled}
      {...delegated}
    >
      {icon}
      <span
        className={twJoin(
          "text-label-lg",
          inputText ? "text-text-secondary" : "text-text-primary-active",
        )}
      >
        {inputText ?? label}
      </span>
    </StyledInputBlock>
  );
}

const StyledInputBlock = styled(InputBlock)`
  overflow: hidden;
  width: 100%;
`;
